/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AcceptConsultParams {
  channelId?: string;
  /** @format int32 */
  consultId: number;
  messageId?: string;
}

/**
 * Contains all validated details required to finalize a session booking.
 * Ensure all fields are derived from the current conversation state and confirmed by the user before submission.
 */
export interface AiGuideBotModelsBookSessionRequest {
  /** The unique identifier of the selected expert for this session. */
  expertId: string;
  /** Preferred session language code (e.g., 'en-US' or 'nl-NL') as confirmed by the user. */
  language: string;
  /**
   * Chosen UTC start time for the session, picked from available expert slots.
   * @format date-time
   */
  sessionDateTime: string;
  /** Session type (e.g., 'general' or 'physical-wellbeing') that matches the user's need. */
  sessionType: string;
  /** The user's preferred time zone used for confirming the final slot timing. */
  timezone: string;
}

/**
 * Body of a chat-bot streaming request: the full client-owned message history plus
 * the caller's time zone, forwarded to the AI Coach.
 */
export interface AiGuideBotModelsChatRequest {
  /** The user's time zone (IANA or Windows), used to localise session times. */
  clientTimezone: string;
  /** The conversation messages, sent in full by the client on every turn. */
  messages: AiGuideBotModelsChatRequestMessage[];
}

/** A single message in a AiGuideBot.Models.ChatRequest. */
export interface AiGuideBotModelsChatRequestMessage {
  /** Message text content. */
  content: string;
  /**
   * When the message was created on the client.
   * @format date-time
   */
  createdAt: string;
  /** Client-owned message identifier (e.g. the Vercel AI SDK message id). */
  id: string;
  /** Message role: `user` or `assistant`. */
  role: string;
}

/**
 * Summary card for an expert, returned by the matching and last-session tools and
 * rendered by the client during the booking flow.
 */
export interface AiGuideBotModelsExpertCardData {
  /** Short label on the card (e.g. "Best Match" or "Recommended"). */
  caption?: null | string;
  /** Short profile description used to introduce the expert. */
  description?: null | string;
  /** Expert's first name, shown on the card and in confirmations. */
  expertFirstName?: null | string;
  /** Unique identifier of the expert, used as the key for availability and booking. */
  expertId?: null | string;
  /** Expert's last name. */
  expertLastName?: null | string;
  /** URL of the expert's profile image. */
  imageUrl?: null | string;
  /** Optional client-side selection key, set when the card is returned as a choice option. */
  key?: null | string;
  /** Language codes the expert can deliver sessions in. */
  languageCodes: string[];
  /** Public profile page URL for the expert. */
  profileUrl?: null | string;
  /** Expert's specialisation, localised to the requested language. */
  specialisation?: null | string;
  /** Comma-separated list of the expert's top topics, localised. */
  topics?: null | string;
}

/** Input for content lookup when the user asks for wellbeing material. */
export interface AiGuideBotModelsSearchContentRequest {
  /**
   * Optional content type filter.
   * Set this only when the user explicitly asks for a format (for example, article or video).
   */
  contentType?: null | string;
  /**
   * Language code used to filter results, such as `en-GB` or `nl-NL`.
   * Keep this aligned with the user's mentioned language.
   */
  language: string;
  /**
   * Zero-based page number for pagination.
   * Start with `0` and increment only if more results are needed.
   * @format int32
   */
  pageIndex: number;
  /**
   * Main user topic or question to search for.
   * Prefer the user's exact wording from the latest turn.
   */
  topic: string;
  /**
   * Id of the end user the search is performed for, used by the service-authenticated v2
   * endpoint. Required for content that is gated per user, such as audio exercises; omit it and
   * that content is left out of the results.
   * The v1 endpoint ignores this and takes the user from the caller's own bearer token.
   */
  userId?: null | string;
}

/**
 * Contains the details needed to submit a help desk support request on behalf of the user.
 * The endpoint generates a conversation summary internally and emails it to the support team.
 * Only call this after the user has explicitly confirmed they want their request submitted.
 */
export interface AiGuideBotModelsSubmitHelpDeskRequest {
  /**
   * The current chat conversation identifier. The endpoint loads this conversation, generates a summary, and emails it to the support team.
   * @format uuid
   */
  conversationId: string;
}

/** Request model for patching a conversation's mutable fields. */
export interface AiGuideBotModelsUpdateConversationRequest {
  /** The new conversation title. */
  title: string;
}

/** Request model for updating an existing conversation message's metadata. */
export interface AiGuideBotModelsUpdateMessageRequest {
  /** Optional message-type discriminator (e.g. a choice-prompt type). */
  messageType?: null | string;
  /** Optional metadata key/value pairs to merge onto the message (e.g. marking a choice as responded). */
  metadata?: null | object;
  /** Optional structured payload associated with the message type. */
  payload?: null;
  /** Optional replacement text for the message. */
  text?: null | string;
}

/**
 * Confirms the details of a successfully booked session.
 * Use this data to provide a final summary and reassure the user that their appointment is scheduled.
 */
export interface AiGuideBotResponsesBookSessionResponse {
  /**
   * The unique identifier for the booked consult.
   * @format int32
   */
  consultId: number;
  /** The unique identifier of the assigned expert. */
  expertId: string;
  /** Optional URL for the expert's profile picture to enhance the confirmation message. */
  expertImageUrl?: null | string;
  /** The first name of the expert for the booked session. Use this to confirm the expert to the user. */
  expertName: string;
  /** Public profile link for the expert, provided for the user's reference. */
  expertProfileUrl: string;
  /**
   * The confirmed UTC start time for the session. Use this to inform the user of their appointment time.
   * @format date-time
   */
  sessionDateTime: string;
  /** The language confirmed for the session. */
  sessionLanguage: string;
  /** The confirmed session type. */
  sessionType: string;
  /** The user's preferred time zone for the booking. */
  timezone: string;
}

/** A single stored conversation message returned when listing a conversation's messages. */
export interface AiGuideBotResponsesConversationMessageResponse {
  /** Message text content. */
  content: string;
  /**
   * When the message was created.
   * @format date-time
   */
  createdAt: string;
  /** The message identifier. */
  id: string;
  /** Optional JSON metadata associated with the message (e.g. a choice-prompt state). */
  metadata?: null | string;
  /** Message role: `user` or `assistant`. */
  role: string;
}

/**
 * Provides information about the user's most recent completed session.
 * Use this to suggest the same expert for follow-up appointments or to acknowledge their history with OpenUp.
 */
export interface AiGuideBotResponsesGetLastSessionResponse {
  /** Indicates if a matching completed session was found. If false, treat the user as new to this session type. */
  hasPreviousSession: boolean;
  /** The details of the expert from the last session. Use this to offer a 'book again' option with a known face. */
  previousSessionExpert?: AiGuideBotModelsExpertCardData | null;
}

export interface BookNonConfirmedConsultParams {
  email?: string;
}

export interface BookNonConfirmedConsultWithPsychologistParams {
  email?: string;
  psychologistId: string;
}

export interface ConfirmConsultParams {
  token?: string;
}

export interface ConfirmSpaceUserParams {
  token?: string;
}

export interface ConfirmUserParams {
  /** User verification code */
  token?: string;
}

export interface ConnectTranscriptionParams {
  /** @format int32 */
  consultId: number;
  serverCallId?: string;
}

export interface CreateChannelJsonPayload {
  /** The channel URL */
  channel_url?: string;
  /** The clients to be invited to the channel after its creation */
  client_ids?: string[];
  /**
   * The image file to associate with the channel
   * @format binary
   */
  cover_file?: File;
  /** The URL of the image to associate with the channel */
  cover_url?: string;
  /** A description of the channel */
  description?: string;
  /** If you are creating a 1-on-1 direct messaging channel for a user, it is recommended that you turn on the distinct property. If the property is turned off, a user can create a new channel even if they have had the previous chat between them, and therefore can't see previously sent messages or data in the new channel. On the other hand, if the distinct property is turned on, every 1-on-1 conversation between the same two users occurs within the same channel. */
  is_distinct?: boolean;
  /** Determines whether to preserve the messages in the channel for the purpose of retrieving chat history. (Default: false) */
  is_ephemeral?: boolean;
  /** Determines whether to allow a user to join the channel without an invitation. (Default: false) */
  is_public?: boolean;
  /**
   *  Determines whether to allow the channel to accommodate more than 2,000 members. (Default: false)
   * * Supergroup channels are not supported with the is_distinct property and the property is false by default.
   */
  is_super?: boolean;
  /** The channel language */
  language?: string;
  /** The name of the channel */
  name?: string;
}

export type CreateEmployer2Payload = any;

export interface CreateGuestUserParams {
  /** User's unconfirmed data token */
  token?: string;
}

export interface DeclineConsultParams {
  channelId?: string;
  /** @format int32 */
  consultId: number;
  messageId?: string;
}

export type DeleteSessionNotePayload = string[];

export interface DossierNote {
  value?: null | string;
}

export interface FindMatchingExpertsParams {
  /** Language code used to filter experts and localize returned fields. */
  language?: string;
  /** Short user summary used for semantic matching against expert profiles. */
  matchingCriteria?: string;
  /** Session type used to restrict matches to relevant experts. */
  sessionType?: string;
}

export interface FindMatchingExpertsParams2 {
  language?: string;
  matchingCriteria?: string;
  sessionType?: string;
}

export interface GenerateInvitationLinkParams {
  channelId?: string;
  isEnabled?: boolean;
}

export interface GeneratePdfParams {
  url?: string;
}

export interface GenerateXlsxParams {
  /** @format date */
  date?: string;
  /** @format uuid */
  employerId: string;
}

export interface GetAccountsCountReportDataParams {
  /** @format date */
  date?: string;
  /** @format uuid */
  employerId: string;
}

export interface GetAccountsCountReportDataParams2 {
  /** @format date */
  date?: string;
  /** @format uuid */
  employerId: string;
}

export interface GetAcsTokenParams {
  roomId?: string;
}

export interface GetAllSessionsParams {
  /** @format uuid */
  employerId?: string;
  expertId?: string;
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
  searchTerm?: string;
  /** @format date-time */
  startedAtFrom?: string;
  /** @format date-time */
  startedAtTo?: string;
  status?: string;
}

export interface GetAudioListParams {
  audience?: string;
  contentGroups?: string[];
  languageCode: string;
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
  themes?: string[];
}

export interface GetAutocompleteParams {
  languageCode?: string;
  /** @format int32 */
  limit?: number;
  q?: string;
}

export interface GetAutocompleteParams2 {
  languageCode?: string;
  /** @format int32 */
  limit?: number;
  q?: string;
}

export interface GetBookmarkedContentsParams {
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
}

export interface GetClientConsultParams {
  /**
   * The consultId
   * @format int32
   */
  consultId: number;
  /** Specific status to exclude in the consult filtering */
  statusToExclude?: string;
  /** Specific status to filter the consult by */
  statusToFilterBy?: string;
}

export interface GetClientConsultsAndSpacesParams {
  /** @default true */
  clientView?: boolean;
  /** @default false */
  includeExpertDetails?: boolean;
  /** @default "en-US" */
  languageCode?: string;
  /** @format int32 */
  limit?: number;
  notesFormat?: string;
  /** @format int32 */
  page?: number;
  search?: string;
}

export interface GetClientConsultsParams {
  clientView?: boolean;
  includeNotes?: boolean;
  notesFormat?: string;
}

export interface GetClientSpacesParams {
  /** userId of client */
  clientId: string;
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
}

export interface GetClientsParams {
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
}

export interface GetConsultsFeedbacksParams {
  /** @format date-time */
  fromDate?: string;
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
}

export interface GetContentsParams {
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
}

export interface GetConversationMessagesParams {
  /** @format date-time */
  endDate?: string;
  /** @format date-time */
  startDate?: string;
}

export interface GetEmployers2Params {
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
}

export interface GetEmployersParams1 {
  /** When true or null, returns only active employers. When false, returns all employers including inactive ones. */
  activeOnly?: boolean;
  /** Optional filter to search employers by company name */
  companyName?: string;
}

export interface GetEngagedUsersReportDataParams {
  /** @format date */
  date?: string;
  /** @format uuid */
  employerId: string;
}

export interface GetEngagedUsersReportDataParams2 {
  /** @format date */
  date?: string;
  /** @format uuid */
  employerId: string;
}

export interface GetExpertFeedbacksParams {
  dateFilter?: string;
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
}

export interface GetExpertFirstAvailableTimeSlotsParams {
  /** Selected expert identifier from the current booking flow. */
  expertId: string;
  /**
   * The earliest UTC date and time to start searching for available slots. Use this if the user requests availability after a specific moment.
   * @format date-time
   */
  fromDateTime?: string;
  /** User's time zone (Windows or IANA) used to localize returned slot times. */
  userTimeZone?: string;
}

export interface GetExpertFirstAvailableTimeSlotsParams2 {
  expertId: string;
  /** @format date-time */
  fromDateTime?: string;
  userTimeZone?: string;
}

export interface GetExpertParams {
  personalUrlHandle: string;
  /** @default "en-GB" */
  profileLanguage?: string;
}

export interface GetExpertTagsParams {
  /** The ID of the client */
  clientId?: string;
  /** The ID of the expert */
  expertId: string;
}

export interface GetExpertsParams {
  active?: boolean;
  expertProfileLanguage?: string;
  languages?: string[];
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
  themes?: string[];
  topics?: string[];
  userNumber?: string;
}

export interface GetHostedSessionsParams {
  /** @format uuid */
  employerId?: string;
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
  /** @format date-time */
  startedAtFrom?: string;
  /** @format date-time */
  startedAtTo?: string;
  status?: string;
}

export interface GetLandingParams {
  language?: string;
  token: string;
}

export interface GetLastCompletedSessionParams {
  /** Session type to match when selecting the last completed session. */
  sessionType?: string;
}

export interface GetLastCompletedSessionParams2 {
  sessionType?: string;
}

export interface GetLatestSpacesParams {
  /**
   * @format int32
   * @default 8
   */
  count?: number;
  language?: string;
  theme?: string;
}

export interface GetLatestVitalityCheckinResultsParams {
  /**
   * Optional check-in date to retrieve results for. If omitted, the latest results are returned.
   * @format date-time
   */
  date?: string;
}

export interface GetLoggedInExpertTagsParams {
  /** The ID of the client */
  clientId?: string;
}

export interface GetManagerMixedContentsParams {
  excludeContentTypes?: string[];
  languageCode?: string;
  topics?: string[];
  /** @format int32 */
  totalCount?: number;
}

export interface GetMixedContentsParams {
  languageCode?: string;
  /** @format int32 */
  totalCount?: number;
}

export interface GetModulesParams {
  languageCode?: string;
}

export interface GetNonConfirmedConsultParams {
  token?: string;
}

export interface GetPagedMixedContentsParams {
  audience?: string;
  language?: string;
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
  themes?: string[];
  type?: string[];
}

export interface GetPsychologistClientsParams {
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
}

export interface GetPsychologistConsultsParams {
  /** @format uuid */
  employerId?: string;
  expertId?: string;
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
  searchTerm?: string;
  /** @format date-time */
  startedAtFrom?: string;
  /** @format date-time */
  startedAtTo?: string;
  status?: string;
}

export interface GetPsychologistsParams {
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
}

export interface GetPublicEventParams {
  /** @format uuid */
  id: string;
  language?: string;
}

export interface GetQuestionListDefinitionParams {
  /** The name of the question list */
  formName?: string;
  /** The language of the question list */
  language?: string;
}

export interface GetRecommendationPlanParams {
  /**
   * Optional check-in timestamp to fetch the plan for. Omit for the latest plan.
   *             Bound as System.DateTimeOffset so the UTC offset ("Z") the browser sends is always honoured —
   *             a plain DateTime query binding can drop the offset and be mis-read against the server's local zone.
   * @format date-time
   */
  checkinDate?: string;
}

export interface GetReferralToolkitFileParams {
  employerId: string;
  fileName?: string;
}

export interface GetSessionNotesParams {
  /** @format date-time */
  fromDate?: string;
  /** @format date-time */
  toDate?: string;
}

export interface GetSessionReferralsParams {
  /** @format date-time */
  fromDate?: string;
  /** @format date-time */
  toDate?: string;
}

export interface GetSessionsThemesDataParams {
  /** @format date */
  date?: string;
  /** @format uuid */
  employerId: string;
}

export interface GetSessionsThemesDataParams2 {
  /** @format date */
  date?: string;
  /** @format uuid */
  employerId: string;
}

export interface GetSessionsThemesForTopicsReportParams {
  /** @format date */
  date?: string;
  /** @format uuid */
  employerId: string;
}

export interface GetSessionsThemesForTopicsReportParams2 {
  /** @format date */
  date?: string;
  /** @format uuid */
  employerId: string;
}

export interface GetSessionsTopicsData2Params {
  /** @format date */
  date?: string;
  /** @format uuid */
  employerId: string;
}

export interface GetSessionsTopicsDataParams {
  /** @format date */
  date?: string;
  /** @format uuid */
  employerId: string;
}

export interface GetSessionsTopicsDataParams2 {
  /** @format date */
  date?: string;
  /** @format uuid */
  employerId: string;
  themeKey: string;
}

export interface GetShortsParams {
  audience?: string;
  language?: string;
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
  themes?: string[];
  type?: string[];
}

export interface GetSpaceEventsParams {
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
}

export interface GetSpacesAutocompleteParams {
  languageCode?: string;
  /** @format int32 */
  limit?: number;
  q?: string;
}

export interface GetTagsAvailableForClientParams {
  availableForUserId?: string;
  tagType: string;
}

export interface GetThemesParams {
  "session_types[]"?: string[];
}

export interface GetTimeSlotsInFirstAvailableWeek3Params {
  /** @format date-time */
  endDate?: string;
  /** @format date-time */
  startDate?: string;
  timeZone?: string;
}

export interface GetTimeSlotsInFirstAvailableWeekParams {
  /** @format date-time */
  endDate?: string;
  psychologistId: string;
  /** @format date-time */
  startDate?: string;
  timeZone?: string;
}

export interface GetTripettoFormDefinitionByThemeParams {
  language?: string;
  themeKeys?: string[];
}

export interface GetTripettoFormDefinitionParams {
  /** The name of the question list */
  formName?: string;
  /** The language of the question list */
  language?: string;
}

export interface GetUserQuestionListScoresParams {
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  questionListKey?: string;
  search?: string;
}

export interface GetVitalityCheckinParams {
  /** The language code (e.g., "en-GB") */
  language?: string;
  /** The type of check-in (e.g., "stress-and-coping") */
  name?: string;
}

export interface GetVitalityCheckinRecommendationsParams {
  /** @default "en" */
  languageCode?: string;
}

export interface GetWhoElseInCallParams {
  roomId?: string;
}

export interface IsExpertInCallParams {
  roomId?: string;
}

export interface LastCompletedConsultsByTypeParams {
  /** @default false */
  includeExpertDetails?: boolean;
  /** @default "en-US" */
  languageCode?: string;
}

export interface LoginGuestParams {
  token?: string;
}

export interface MicrosoftAspNetCoreMvcProblemDetails {
  detail?: null | string;
  instance?: null | string;
  /** @format int32 */
  status?: null | number;
  title?: null | string;
  type?: null | string;
  [key: string]: any;
}

export interface ModelsAiGuideConversationSummary {
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  /** @format date-time */
  lastModifiedAt?: null | string;
  preview?: null | string;
  title?: null | string;
}

export interface ModelsAiSearchFaqSearchResultItem {
  answer?: null | string;
  question?: null | string;
}

export interface ModelsAiSearchSlugNamePair {
  name?: null | string;
  slug?: null | string;
}

export interface ModelsAiSearchSpeakerAvatar {
  large?: null | string;
  medium?: null | string;
  src?: null | string;
  thumbnail?: null | string;
}

export interface ModelsAiSearchSpeakerDetails {
  avatar: ModelsAiSearchSpeakerAvatar;
  name?: null | string;
}

export interface ModelsAnswer {
  /** @format date-time */
  dateValue?: null | string;
  /** @format int32 */
  intValue?: null | number;
  name?: null | string;
  textValue?: null | string;
}

export interface ModelsCalendar {
  accessToken?: null | string;
  /** @format date-time */
  accessTokenExpiration?: null | string;
  calendarId?: null | string;
  description?: null | string;
  /** @format date-time */
  lastUpdatedAt?: null | string;
  refreshToken?: null | string;
  summary?: null | string;
  timeZone?: null | string;
  userId?: null | string;
  /** @format date-time */
  watchResourceExpiration?: null | string;
  watchResourceId?: null | string;
}

export interface ModelsChatChannelInvitationToken {
  channelId?: null | string;
  invitationLink?: null | string;
  isEnabled: boolean;
}

export interface ModelsCompanyReportThemesReport {
  employerId?: null | string;
  key?: null | string;
  /** @format double */
  lastThreeMonthsCurrentPeriod: number;
  /** @format double */
  previousThreeMonths: number;
}

export enum ModelsConsultMeetingProvider {
  None = "None",
  Sessions24 = "Sessions24",
  Acs = "Acs",
}

export interface ModelsConsultReview {
  /** @format int32 */
  answer1: number;
  /** @format int32 */
  answer2: number;
  /** @format int32 */
  answer3: number;
  answer4: boolean;
  answer5: boolean;
  answer6: boolean;
  feedback?: null | string;
}

/** @format int32 */
export enum ModelsConsultStatus {
  Scheduled = "Scheduled",
  CancelledByClient = "CancelledByClient",
  CancelledByOpenUp = "CancelledByOpenUp",
  Completed = "Completed",
  MissedByClient = "MissedByClient",
  MissedByOpenUp = "MissedByOpenUp",
  MissedByBoth = "MissedByBoth",
}

export interface ModelsContentsContent {
  coverImage: ModelsCoverImage;
  /** @format date-time */
  createdAt: string;
  /** @format int32 */
  durationInSeconds: number;
  /** @format int64 */
  id: number;
  isBookmarked?: null | boolean;
  languageCode?: null | string;
  /** @format date-time */
  modifiedAt?: null | string;
  /** @format int32 */
  order: number;
  orientation?: null | string;
  /** @format int64 */
  parentId?: null | number;
  provider?: null | string;
  slug?: null | string;
  status?: null | string;
  themes?: null | any[];
  thumbnailPath?: null | string;
  title?: null | string;
  translations?: null | any[];
  type?: null | string;
  url?: null | string;
  userGroups?: null | any[];
  videoFormat?: null | string;
}

export interface ModelsCoverImage {
  large?: null | string;
  medium?: null | string;
  source?: null | string;
  thumbnail?: null | string;
}

export interface ModelsDtosTimezoneDto {
  name?: null | string;
  /** @format 0.00:00:00 */
  utcOffset: string;
  /** @format double */
  utcOffsetInMinutes: number;
  zoneId?: null | string;
}

export interface ModelsEmployer {
  active: boolean;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  name?: null | string;
  planhatId?: null | string;
  slug?: null | string;
}

/** @format int32 */
export enum ModelsEnumCategory {
  None = "None",
  Low = "Low",
  Medium = "Medium",
  High = "High",
}

export interface ModelsExternalQuestionnaire {
  clientId?: null | string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  externalId: string;
  /** @format uuid */
  id: string;
  resultLink?: null | string;
  shareLink?: null | string;
  type?: null | string;
}

export interface ModelsFormDefinition {
  definition?: null | string;
  locale?: null | string;
  modules?: null | any[];
  styles?: null | string;
  translations?: null | string;
}

export interface ModelsNotes {
  answer?: null | string;
  /** @format int32 */
  consultId: number;
  question?: null | string;
}

/** @format int32 */
export enum ModelsOpenUpRole {
  Automation = "Automation",
  Guest = "Guest",
  Client = "Client",
  Expert = "Expert",
  Admin = "Admin",
  Manager = "Manager",
  Consult = "Consult",
  Checkin = "Checkin",
  Host = "Host",
  CustomerSuccess = "CustomerSuccess",
  HumanResource = "HumanResource",
  Support = "Support",
}

export interface ModelsQuestion {
  answers?: null | any[];
  goal?: null | string;
  isNegated: boolean;
  isScored: boolean;
  key?: null | string;
  /** @format int32 */
  ordinal: number;
  questionType: ModelsQuestionType;
  /** @format int32 */
  rank?: null | number;
  /** @format int32 */
  scale?: null | number;
  /** @format double */
  score: number;
  text?: null | string;
  tip?: null | string;
  /** @format double */
  weight: number;
}

export interface ModelsQuestionListAnswer {
  answers?: null | any[];
  questionKey?: null | string;
  questionText?: null | string;
  questionType?: null | string;
}

export interface ModelsQuestionListAnswers {
  answers?: null | any[];
  languageCode?: null | string;
  questionListKey?: null | string;
}

/** @format int32 */
export enum ModelsQuestionType {
  MultipleChoice = "MultipleChoice",
  CheckBox = "CheckBox",
  CheckBoxes = "CheckBoxes",
  Date = "Date",
  Dropdown = "Dropdown",
  Email = "Email",
  FileUpload = "FileUpload",
  Matrix = "Matrix",
  Number = "Number",
  Paragraph = "Paragraph",
  Password = "Password",
  PhoneNumber = "PhoneNumber",
  PictureChoice = "PictureChoice",
  RadioButtons = "RadioButtons",
  Rating = "Rating",
  Scale = "Scale",
  Statement = "Statement",
  TextArea = "TextArea",
  Url = "Url",
  YesNo = "YesNo",
  Text = "Text",
  HiddenField = "HiddenField",
  CalculatorBlock = "CalculatorBlock",
}

export interface ModelsQuestionsQuestionList {
  category: ModelsEnumCategory;
  categoryTitle?: null | string;
  /** @format date-time */
  createdAt: string;
  key?: null | string;
  language?: null | string;
  questions?: null | any[];
  /** @format double */
  score: number;
  scoreDescription?: null | string;
  scoreIconInUnicode?: null | string;
  scoreTitle?: null | string;
  themeKey?: null | string;
  /** @format uuid */
  userId: string;
}

/** @format int32 */
export enum ModelsRequestSource {
  IsClientApp = "IsClientApp",
  IsDashboard = "IsDashboard",
  IsMobileiOS = "IsMobileiOS",
  IsMobileAndroid = "IsMobileAndroid",
  IsCustomerSuccess = "IsCustomerSuccess",
  IsSpaces = "IsSpaces",
}

export interface ModelsSendBirdModelsSendBirdChannelResponse {
  access_code?: null | string;
  channel_url?: null | string;
  cover_url?: null | string;
  custom_type?: null | string;
  data?: null | string;
  inviter_id?: null | string;
  is_distinct: boolean;
  is_ephemeral: boolean;
  is_public: boolean;
  is_super: boolean;
  members?: null | any[];
  name?: null | string;
  operator_ids?: null | any[];
  operators?: null | any[];
  user_ids?: null | any[];
}

export interface ModelsTag {
  description?: null | string;
  name?: null | string;
  tagType: ModelsTagType;
}

export interface ModelsTagType {
  isExclusive: boolean;
  name?: null | string;
  tags?: null | any[];
}

export interface ModelsTheme {
  /** @format date-time */
  createdAt: string;
  isFocused: boolean;
  isTrackedTheme: boolean;
  key?: null | string;
  /** @format date-time */
  lastModifiedAt: string;
  /** @format int32 */
  ordinal?: null | number;
  questionLists?: null | any[];
  tags?: null | any[];
  /** @format uuid */
  themeDefinitionId: string;
  userId?: null | string;
}

export interface ModelsTimeSlot {
  /** @format date-time */
  endTime: string;
  /** @format date-time */
  startTime: string;
}

export enum ModelsTwoFactorAuthMethod {
  Phone = "Phone",
  AuthenticatorKey = "AuthenticatorKey",
}

export interface ModelsUser {
  /** @format date-time */
  acceptedMedicalDataProcessing?: null | string;
  /** @format date-time */
  acceptedTermsAndConditions: string;
  calendar: ModelsCalendar;
  /** @format date-time */
  createdAt: string;
  createdBy?: null | string;
  /**
   * @format email
   * @minLength 1
   */
  email: string;
  /** @format uuid */
  employerId?: null | string;
  employerName?: null | string;
  /**
   * @minLength 1
   * @maxLength 25
   */
  firstName: string;
  hasDeskJob?: null | boolean;
  id?: null | string;
  isAiPersonalisedRecommendationsEnabled: boolean;
  isEmailConfirmed: boolean;
  isFocusThemeSet?: null | boolean;
  isManager?: null | boolean;
  isPartner: boolean;
  readonly isRegistered: boolean;
  isSignedUpToNewsLetter: boolean;
  isTouchedByPsychologist: boolean;
  isTranscriptionAllowed: boolean;
  languageCode?: null | string;
  /** @format date-time */
  lastLoginAt?: null | string;
  /**
   * @minLength 1
   * @maxLength 25
   */
  lastName?: null | string;
  lockoutEnabled: boolean;
  /** @format date-time */
  lockoutEnd?: null | string;
  loginProvider?: null | string;
  passwordHash?: null | string;
  personalUrlHandle?: null | string;
  /** @format tel */
  phoneNumber?: null | string;
  phoneNumberConfirmed: boolean;
  preferences?: null | any[];
  roles?: null | any[];
  signUpToNewsletter: boolean;
  tags?: null | any[];
  /** @format int32 */
  twoFactorCodeRequestCount: number;
  /** @format date-time */
  twoFactorCodeRequestedAt?: null | string;
  twoFactorEnabled: boolean;
  /** @format int32 */
  userNumber: number;
  worksTwentyFourSeven: boolean;
  /** @format int32 */
  yearOfBirth?: null | number;
}

export interface ModelsUserPreference {
  category?: null | string;
  name?: null | string;
  value: boolean;
}

export type NewtonsoftJsonLinqJToken = NewtonsoftJsonLinqJToken[];

export interface OpenUpBIApiResponsesConsultFeedbackWithEmployerResponse {
  clientId: string;
  /** @format date */
  consultMonth: string;
  /** @format uuid */
  employerId: string;
  employerName: string;
  feedback: string;
}

export interface OpenUpBIApiResponsesConsultFeedbackWithEmployerResponsePaginated {
  data: OpenUpBIApiResponsesConsultFeedbackWithEmployerResponse[];
  pagination: ResponsePagination;
}

export interface OpenUpBIApiResponsesConversationMessagesResponse {
  /** @format uuid */
  chatConversationId: string;
  chatMessageId: string;
  content: string;
  /** @format date-time */
  createdAt: string;
  role: string;
  userId: string;
}

export interface OpenUpBIApiResponsesSessionNotesResponse {
  /** @format int32 */
  consultId: number;
  /** @format int32 */
  notesWordCount: number;
}

export interface OpenUpBIApiResponsesSessionReferralsResponse {
  /** @format int32 */
  consultId: number;
  /** @format uuid */
  employerId?: null | string;
  expertId: string;
  nextSteps: string;
  provider: string;
  referrals: string;
  sessionLanguage: string;
  /** @format date-time */
  sessionStartDate: string;
  sessionType: string;
  userId: string;
}

export interface OpenUpEmployeesParams {
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
}

export interface ProviderChallengePayload {
  /** E.g. Google */
  provider?: string;
  /** The OpenUp URL responsible for handling the login response */
  redirectUrl?: string;
}

export type RedactPiiTextPayload = string;

export interface RegisterGuestUserAfterCheckInParams {
  /** Is this a medical checkin */
  isMedicalCheckin?: boolean;
}

export interface RegisterUserAndConfirmConsultParams {
  token?: string;
}

export interface RequestAvailableTimeSlotsRequest {
  /** @format date-time */
  endDate?: null | string;
  excludedExpertIds?: null | any[];
  /** @format date-time */
  startDate: string;
  tags?: null | any[];
  timeZone?: null | string;
}

export interface RequestBookSlotRequest {
  previousExpertId?: null | string;
  recaptchaToken?: null | string;
  sessionContext?: null | string;
  tags: RequestTag[];
  /** @format date-time */
  time: string;
  timezone: string;
}

export interface RequestCancelConsultRequest {
  reason?: null | string;
}

export interface RequestChangePasswordRequest {
  newPassword?: null | string;
  oldPassword?: null | string;
}

export interface RequestClientCreateRequest {
  email?: null | string;
  /** @format uuid */
  employerId?: null | string;
  firstName?: null | string;
  gender?: null | string;
  isPartner: boolean;
  languageCode?: null | string;
  lastName?: null | string;
  phoneNumber?: null | string;
  /** @format int32 */
  yearOfBirth?: null | number;
}

export interface RequestClientUpdateRequest {
  /** @format uuid */
  employerId?: null | string;
  firstName?: null | string;
  gender?: null | string;
  isPartner: boolean;
  languageCode?: null | string;
  lastName?: null | string;
  phoneNumber?: null | string;
  /** @format int32 */
  yearOfBirth?: null | number;
}

export interface RequestCodeFlowRequest {
  code?: null | string;
  domain?: null | string;
}

export interface RequestConfirmConsultRequest {
  recaptchaToken?: null | string;
}

export interface RequestConsultCreateRequest {
  /** @minLength 1 */
  clientTimezone: string;
  consultLanguage?: null | string;
  consultType?: null | string;
  /** @minLength 1 */
  employeeId: string;
  /** @format string */
  notes?: null | string;
  /** @format date-time */
  startedAt: string;
  status: ModelsConsultStatus;
  themeKey?: null | string;
  /** @minLength 1 */
  userId: string;
}

export interface RequestConsultUpdateRequest {
  consultLanguage?: null | string;
  consultType?: null | string;
  /** @minLength 1 */
  employeeId: string;
  notes?: null | string;
  /** @format date-time */
  startedAt: string;
  status: ModelsConsultStatus;
}

export interface RequestContentContentBookmarkedRequest {
  audience?: null | string;
  language?: null | string;
  themes?: null | any[];
  type?: null | any[];
}

export interface RequestContentContentEventRequest {
  /** @format int64 */
  contentId: number;
  entityId?: null | string;
  entityType?: null | string;
  eventType?: null | string;
  isRecommended?: null | boolean;
  metadata: RequestContentMetaDataRequest;
  platform?: null | string;
}

export interface RequestContentContentRequest {
  audience?: null | string;
  language?: null | string;
  themes?: null | any[];
  type?: null | any[];
}

export interface RequestContentDataRequest {
  key?: null | string;
  value?: null | string;
}

export interface RequestContentMetaDataRequest {
  data?: null | any[];
  section?: null | string;
  userAgent?: null | string;
  view?: null | string;
}

export interface RequestContentUpdateContentEngagementRequest {
  status?: null | string;
}

export interface RequestContentWordpressContentNotificationRequest {
  /** @format int64 */
  id: number;
  /** @format int64 */
  lessonId?: null | number;
  status?: null | string;
  type?: null | string;
}

/**
 * Request body for `POST /api/v1/convene/sessions/{id}/cancel` and
 * `POST /api/v1/convene/events/{id}/cancel` (OI-24717).
 */
export interface RequestConveneCancelRequest {
  /**
   * Optional reason shown to attendees in the cancellation email
   * (`cancellationAdditionalInformation`); the template has fallback copy when blank.
   */
  reason?: null | string;
}

/** Request body for `POST /api/v1/convene/events`. Audience is implicitly Private. */
export interface RequestConveneCreateEventRequest {
  description?: null | string;
  /** Audience name shown on the public event page; null falls back to the employer's own name. */
  employerDisplayName?: null | string;
  /** Every company the event is open to; at least one is required. */
  employerIds: string[];
  /** Event sub-type: "groupsession" (Zoom meeting) or "masterclass" (Zoom webinar). */
  eventType: string;
  sessions: RequestConveneCreateSessionRequest[];
  /**
   * Optional third-party survey URL attendees are sent to when a session ends
   * (Zoom `settings.survey_url`). Masterclasses only — rejected for group sessions.
   */
  surveyUrl?: null | string;
  title: string;
}

/** Request body for `POST /convene/sessions/{sessionId}/invite-link` (OI-24714). */
export interface RequestConveneCreateInviteLinkRequest {
  /**
   * Maximum registrations through the link; null = uncapped (session capacity still applies).
   * @format int32
   */
  seatCap?: null | number;
}

/** Request body for `POST /convene/sessions/{sessionId}/invites`. */
export interface RequestConveneCreateInvitesRequest {
  /** Invitee email addresses; already-invited ones are skipped silently. */
  emails: string[];
}

/**
 * An expert assignment in the create payload. `Role` is "host" for a host; <b>any other
 * value</b> is read as the non-host role and resolved from the event type, giving a panelist on a
 * masterclass and a co-host on a group session. Send "panelist" or "cohost" to match the response
 * shape, but note the parse is host-or-not rather than a closed set.
 */
export interface RequestConveneCreateSessionExpertRequest {
  role: string;
  userId: string;
}

/** A single session in the create payload (local date/time + duration → one Space). */
export interface RequestConveneCreateSessionRequest {
  /**
   * Optional seat cap; defaults to 100 when omitted.
   * @format int32
   */
  capacity?: null | number;
  /** Local date, "YYYY-MM-DD". */
  date: string;
  /**
   * Session length in minutes; one of 30, 45, 60, 90. The end time is derived.
   * @format int32
   */
  durationMinutes: number;
  experts: RequestConveneCreateSessionExpertRequest[];
  /** Optional session name → Space.Title (falls back to the event title when blank). */
  name?: null | string;
  /** Optional practical notes for attendees, included in confirmation/reminder emails. */
  sessionInstructions?: null | string;
  /** Local start time, "HH:mm". */
  startTime: string;
  /** Optional IANA timezone; defaults to "Europe/Amsterdam" when omitted. */
  timeZone?: null | string;
}

/**
 * Event copy submitted for one non-source language. Both fields optional; an entry with
 *             neither is dropped rather than stored.
 */
export interface RequestConveneEventTranslationRequest {
  description?: null | string;
  languageCode: string;
  title?: null | string;
}

/** Session copy submitted for one non-source language. */
export interface RequestConveneSessionTranslationRequest {
  languageCode: string;
  /** @format uuid */
  sessionId: string;
  sessionInstructions?: null | string;
  title?: null | string;
}

/**
 * Request body for `PATCH /api/v1/convene/events/{eventId}` (OI-25024, non-reschedule
 * edits). Carries the full editable subset — the client always sends every field.
 */
export interface RequestConveneUpdateEventRequest {
  description?: null | string;
  /**
   * Audience name shown on the public event page ("Live session for {name} employees"). Null
   * falls back to the employer's own name. Use it when the employer row names one legal entity
   * but the page reaches the wider company.
   */
  employerDisplayName?: null | string;
  /**
   * Every company the event is open to; a full replace, so a company left out is removed. Removing
   * one stops future registrations from it and leaves existing ones alone.
   */
  employerIds: string[];
  /**
   * Locale code the event's own Title/Description are written in, e.g. "nl-NL". Must be set
   * before any translation is sent. Events created before multilingual content have none until a
   * scheduler declares one.
   */
  languageCode?: null | string;
  /** Session copy in other languages, for sessions of this event. Same full-replace rule. */
  sessionTranslations: RequestConveneSessionTranslationRequest[];
  /**
   * Third-party survey URL attendees are sent to when a session ends (masterclasses only).
   * Null clears it — like the other fields, the client always sends the full editable subset.
   */
  surveyUrl?: null | string;
  title: string;
  /**
   * Event copy in other languages; a full replace, so a language left out is removed. Sending the
   * event's own language is rejected (TRANSLATION_IN_SOURCE_LANGUAGE) — that copy is Title and
   * Description above.
   */
  translations: RequestConveneEventTranslationRequest[];
}

/**
 * Request body for `PATCH /api/v1/convene/sessions/{sessionId}` (OI-24717). Carries the full
 * editable subset — the client always sends every field. Changing the date/time/timezone is a
 * reschedule (notifies registered attendees via email 177); changing experts updates Zoom hosts
 * but does not email.
 */
export interface RequestConveneUpdateSessionRequest {
  /**
   * Seat cap; must be positive and at least the current registered count.
   * @format int32
   */
  capacity: number;
  /** Local date, "YYYY-MM-DD". */
  date: string;
  /**
   * Session length in minutes; the end time is derived.
   * @format int32
   */
  durationMinutes: number;
  /** The full set of experts the session should have after the edit. */
  experts: RequestConveneCreateSessionExpertRequest[];
  /** Optional session name; blank falls back to the event title (mirrors creation). */
  name?: null | string;
  /** Optional scheduler note included in the reschedule email; blank → template fallback. */
  rescheduleAdditionalInformation?: null | string;
  /** Optional practical notes for attendees; blank clears them. */
  sessionInstructions?: null | string;
  /** Local start time, "HH:mm". */
  startTime: string;
  /** Optional IANA timezone; defaults to "Europe/Amsterdam" when omitted. */
  timeZone?: null | string;
}

export interface RequestCreateHumanResourcesUserRequest {
  email?: null | string;
  firstName?: null | string;
  lastName?: null | string;
  preferredLanguage?: null | string;
}

export interface RequestEmployerSsoRequest {
  email?: null | string;
}

export interface RequestEmployersAddEmployerRequest {
  name?: null | string;
  planhatId?: null | string;
}

export interface RequestEventEventRequest {
  entityId: string;
  entityType: string;
  eventType: string;
  isRecommended: boolean;
  metadata?: RequestContentMetaDataRequest | null;
  platform: string;
}

export interface RequestExchangeCodeForTokenRequest {
  code?: null | string;
  domain?: null | string;
  provider?: null | string;
  requestSource: ModelsRequestSource;
}

export interface RequestExpertsEditExpertDetailsRequest {
  isTranscriptionAllowed?: null | boolean;
  worksTwentyFourSeven?: null | boolean;
}

export interface RequestExpertsSessionTypeLanguagePairRequest {
  language?: null | string;
  sessionType?: null | string;
}

export interface RequestFilterPsychologistsRequest {
  tags?: null | any[];
  themes?: null | any[];
}

export interface RequestFormAnswersRequest {
  answers?: null | object;
  formLanguage?: null | string;
  formModules?: null | any[];
}

export interface RequestIdTokenRequest {
  idToken?: null | string;
  provider?: null | string;
}

/** Request object to authenticate user using login API */
export interface RequestLoginRequest {
  /**
   * @format password
   * @minLength 0
   * @maxLength 255
   */
  password: string;
  recaptchaToken?: null | string;
  /**
   * @format email
   * @minLength 1
   */
  userName: string;
}

export interface RequestOtpRequest {
  email?: null | string;
  returnUrl?: null | string;
}

export interface RequestRefreshTokenRequest {
  token?: null | string;
}

export interface RequestRegisterCalendarRequest {
  calendarId?: null | string;
}

export interface RequestRegisterGuestUserRequest {
  acceptedMedicalDataProcessing: boolean;
  acceptedTermsAndConditions: boolean;
  email?: null | string;
  /** @format uuid */
  employerId?: null | string;
  firstName?: null | string;
  hasDeskJob?: null | boolean;
  isManager?: null | boolean;
  isPartner: boolean;
  lastName?: null | string;
  phoneNumber?: null | string;
  recaptchaToken?: null | string;
  /** @format int32 */
  yearOfBirth?: null | number;
}

export interface RequestRegisterUserRequest {
  acceptedMedicalDataProcessing: boolean;
  acceptedTermsAndConditions: boolean;
  email?: null | string;
  /** @format uuid */
  employerId?: null | string;
  firstName?: null | string;
  focusThemes?: null | any[];
  hasDeskJob?: null | boolean;
  isManager?: null | boolean;
  isPartner: boolean;
  languageCode?: null | string;
  lastName?: null | string;
  password?: null | string;
  recaptchaToken?: null | string;
  redirectUri?: null | string;
  /** @format int32 */
  yearOfBirth?: null | number;
}

export interface RequestRescheduleConsultRequest {
  /** @format date-time */
  endStart: string;
  /** @format date-time */
  newStart: string;
  reason?: null | string;
  timezone?: null | string;
}

export interface RequestReschedulerSlotByTagsRequest {
  /** @format int32 */
  consultId: number;
  tags?: null | any[];
  /** @format date-time */
  time: string;
  timezone?: null | string;
}

export interface RequestReschedulerSlotWithPsychologistRequest {
  /** @format int32 */
  consultId: number;
  /** @format date-time */
  time: string;
  timezone?: null | string;
}

export interface RequestResetPasswordRequest {
  code?: null | string;
  password?: null | string;
  recaptchaToken?: null | string;
  /** Email */
  userId?: null | string;
}

export interface RequestSendAdminMessageRequest {
  channelUrl?: null | string;
  customType?: null | string;
  hideFromOverview: boolean;
  isSilent: boolean;
  message?: null | string;
  sendPush: boolean;
}

export interface RequestSendPasswordResetEmailRequest {
  email?: null | string;
  recaptchaToken?: null | string;
  redirectUrl?: null | string;
}

export interface RequestSpacesConfirmSpaceUserRequest {
  /**
   * @format email
   * @minLength 1
   */
  email: string;
}

export interface RequestSpacesCreateSpaceUserRequest {
  email?: null | string;
  externalSpaceId?: null | string;
  sessionMetadata: RequestSpacesSessionMetadata;
}

export interface RequestSpacesSessionMetadata {
  /** @format uuid */
  eventId: string;
  eventTitle?: null | string;
  eventTypes: RequestSpacesSpaceSessionEventRequest;
  experts?: null | any[];
  languageCode?: null | string;
  /** @format int64 */
  spaceDateTime: number;
  /** @format uuid */
  spaceSessionId: string;
  themes?: null | any[];
  timezone?: null | string;
}

export interface RequestSpacesSpaceEventRequest {
  audience?: null | string;
  eventTypes?: null | any[];
  /** @minLength 1 */
  languageCode: string;
  themes?: null | any[];
}

export interface RequestSpacesSpaceSessionEventRequest {
  name?: null | string;
  slug?: null | string;
}

export interface RequestSpacesSpaceSessionExpertRequest {
  email?: null | string;
  firstName?: null | string;
  lastName?: null | string;
}

export interface RequestSpacesSpaceSessionThemeRequest {
  name?: null | string;
  slug?: null | string;
}

export interface RequestTag {
  description?: null | string;
  tagName?: null | string;
  tagType?: null | string;
  translations?: null | any[];
}

/** Model to catch the incoming request to set/filter by theme */
export interface RequestTheme {
  /** Should be false for setting a psychologist theme */
  isFocused: boolean;
  /** Key including the theme as a string */
  key?: null | string;
}

export interface RequestTwoFactorAuthenticationTwoFactorChangeStateRequest {
  code?: null | string;
  enable: boolean;
  method: ModelsTwoFactorAuthMethod;
}

export interface RequestTwoFactorAuthenticationTwoFactorCodeVerificationRequest {
  code?: null | string;
  method: ModelsTwoFactorAuthMethod;
}

export interface RequestUnconfirmedUnconfirmedFormAnswersRequest {
  answers?: null | object;
  email?: null | string;
  formLanguage?: null | string;
  formModules?: null | any[];
  unconfirmedDataId?: null | string;
}

export interface RequestUnconfirmedUnconfirmedQuestionListAnswersRequest {
  answers?: null | any[];
  email?: null | string;
  languageCode?: null | string;
  questionListKey?: null | string;
  unconfirmedDataId?: null | string;
}

export interface RequestUnconfirmedUnconfirmedUserCurrentMood {
  currentMoods?: null | any[];
  email?: null | string;
  unconfirmedDataId?: null | string;
}

export interface RequestUnconfirmedUnconfirmedUserPreferencesRequest {
  email?: null | string;
  preferences?: null | any[];
  unconfirmedDataId?: null | string;
}

export interface RequestUpdateLanguageCodeRequest {
  languageCode?: null | string;
}

export interface RequestUpdatePhoneNumberRequest {
  /**
   * @format tel
   * @minLength 0
   * @maxLength 20
   */
  number: string;
}

export interface RequestUpdateSessionNotesRequest {
  answer?: null | string;
  question?: null | string;
}

export interface RequestUpdateUserRequest {
  acceptedMedicalDataProcessing: boolean;
  acceptedTermsAndConditions: boolean;
  /** @format uuid */
  employerId?: null | string;
  firstName?: null | string;
  hasDeskJob?: null | boolean;
  isAiPersonalisedRecommendationsEnabled?: null | boolean;
  isManager?: null | boolean;
  isPartner?: null | boolean;
  isTranscriptionAllowed?: null | boolean;
  languageCode?: null | string;
  lastName?: null | string;
  phoneNumber?: null | string;
  signUpToNewsletter: boolean;
  /** @format int32 */
  yearOfBirth?: null | number;
}

export interface RequestUserConfirmationSignature {
  signature?: null | string;
}

export interface RequestUsersCheckPasswordStrengthRequest {
  password?: null | string;
}

export interface RequestUsersOtpLoginRequest {
  email?: null | string;
  password?: null | string;
}

export interface RequestVitalityCheckinUpdateRecommendationItemStatusRequest {
  /** New item status: "Active" or "Completed". */
  status?: null | string;
}

export interface ResponseAcsAcsChatFile {
  fileName?: null | string;
  url?: null | string;
}

export interface ResponseAcsGetWhoElseInCallResponse {
  name?: null | string;
  userId?: null | string;
}

export interface ResponseAzureCommunicationServiceToken {
  communicationUserId?: null | string;
  endpointUrl?: null | string;
  /** @format date-time */
  expiresOn: string;
  firstName?: null | string;
  token?: null | string;
}

export interface ResponseClientSessionResponse {
  connectionLink?: null | string;
  consultOrSpace?: null | string;
  dossierNotes?: null | any[];
  /** The psychologist ID for 1:1 consults */
  expertId?: null | string;
  expertImageUrl?: null | string;
  expertThumbnailUrl?: null | string;
  experts?: null | any[];
  languageCode?: null | string;
  /** @format date-time */
  notesAvailableAt?: null | string;
  sessionId?: null | string;
  shortDiscussedNotes?: null | string;
  /** @format date-time */
  startAt: string;
  status?: null | string;
  themeKey?: null | string;
  timezone?: null | string;
  title?: null | string;
  type?: null | string;
}

export interface ResponseClientSessionResponsePaginated {
  data: ResponseClientSessionResponse[];
  pagination: ResponsePagination;
}

export interface ResponseConsultResponse {
  clientEmail?: null | string;
  clientFirstName?: null | string;
  clientId?: null | string;
  clientTimezone?: null | string;
  consultLanguage?: null | string;
  consultType?: null | string;
  dossierNotes?: null | any[];
  employeeFullName?: null | string;
  employeeId?: null | string;
  /** @format int32 */
  id: number;
  noteAttachments?: null | any[];
  /** @format date-time */
  notesAvailableAt?: null | string;
  /** @format date-time */
  startedAt: string;
  status?: null | string;
  themeKey?: null | string;
}

export interface ResponseConsultsConsultFeedbackAnswerResponse {
  questionKey: string;
  questionType: string;
  value?: null | string;
}

export interface ResponseConsultsConsultFeedbackResponse {
  answers: ResponseConsultsConsultFeedbackAnswerResponse[];
  clientEmail: string;
  clientFirstName: string;
  clientId: string;
  clientLastName: string;
  /** @format int64 */
  consultId: number;
  consultType: string;
  /** @format date-time */
  startedAt: string;
}

export interface ResponseConsultsConsultFeedbackResponsePaginated {
  data: ResponseConsultsConsultFeedbackResponse[];
  pagination: ResponsePagination;
}

export interface ResponseConsultsConsultSessionDetailsForAnalysisResponse {
  language?: null | string;
  sessionNotes?: null | string;
  /** TODO: replace with a one-way hash for full anonymization */
  sessionTranscript?: null | string;
}

export interface ResponseConsultsConsultWithNotesResponse {
  canJoinVideoCall: boolean;
  chatThreadId?: null | string;
  clientTimezone?: null | string;
  consultLanguage?: null | string;
  consultStage?: null | string;
  consultType?: null | string;
  convertedToMarkDown: boolean;
  dossierNotes?: null | any[];
  employee: ResponsePsychologistResponse;
  employeeFullName?: null | string;
  employerOfClientHasReferralToolkit: boolean;
  hasTranscription: boolean;
  /** @format int32 */
  id: number;
  notes?: null | string;
  roomId?: null | string;
  /** @format date-time */
  startedAt: string;
  status?: null | string;
  themeKey?: null | string;
  user: ResponseUsersUserWithNameAndEmployerIdResponse;
}

export interface ResponseConsultsConsultWithShortNotesResponse {
  consultType?: null | string;
  employeeFullName?: null | string;
  /** @format int32 */
  id: number;
  languageCode?: null | string;
  psychologistUrl?: null | string;
  shortDiscussedNotes?: null | string;
  /** @format date-time */
  startedAt: string;
  status?: null | string;
  themeKey?: null | string;
  userId?: null | string;
}

export interface ResponseConsultsNoteAttachmentFile {
  fileName?: null | string;
  url?: null | string;
}

export interface ResponseContentsArticleAudioFileResponse {
  playlistUrl?: null | string;
  timingUrl?: null | string;
  voiceName?: null | string;
}

export interface ResponseContentsArticleContentResponse {
  contents?: null | any[];
  cta?: null | string;
  isDownloadable: boolean;
  large?: null | string;
  medium?: null | string;
  src?: null | string;
  text?: null | string;
  textStyle?: null | string;
  thumbnail?: null | string;
  title?: null | string;
  type?: null | string;
  url?: null | string;
  variation?: null | string;
}

export interface ResponseContentsArticleResponse {
  aiSummary?: null | string;
  audioFiles?: null | any[];
  authors?: null | any[];
  contents?: null | any[];
  /** @format int32 */
  durationInSeconds: number;
  /** @format int64 */
  id: number;
  isBookmarked: boolean;
  /** @format date-time */
  modifiedAt?: null | string;
  reviewer?: null | string;
  themes?: null | any[];
  thumbnailPath?: null | string;
  title?: null | string;
  url?: null | string;
}

export interface ResponseContentsAudioContentResponse {
  /** Shared author representation for content responses (article, audio, video playback manifest). */
  author?: ResponseContentsContentAuthorResponse | null;
  contentGroups: string[];
  coverImage?: ResponseCoverImageResponse | null;
  description?: null | string;
  /** @format int32 */
  durationMs: number;
  /** @format int64 */
  id: number;
  isBookmarked?: null | boolean;
  language: string;
  themes: string[];
  title: string;
  url?: null | string;
}

export interface ResponseContentsAudioContentResponsePaginated {
  data: ResponseContentsAudioContentResponse[];
  pagination: ResponsePagination;
}

export interface ResponseContentsBookmarkContentResponse {
  /** @format int64 */
  contentId: number;
  isBookmarked: boolean;
}

/** Shared author representation for content responses (article, audio, video playback manifest). */
export interface ResponseContentsContentAuthorResponse {
  avatarUrl?: null | string;
  name?: null | string;
}

export interface ResponseContentsContentAutocompleteResponses {
  autocompleteTerms?: null | any[];
}

export interface ResponseContentsContentResponse {
  coverImage: ResponseCoverImageResponse;
  /** @format date-time */
  createdAt: string;
  /** @format int32 */
  durationInSeconds: number;
  /** @format int64 */
  id: number;
  isBookmarked?: null | boolean;
  orientation?: null | string;
  /**
   * @deprecated
   * @format int32
   */
  readTime: number;
  themes?: null | any[];
  thumbnailPath?: null | string;
  title?: null | string;
  type?: null | string;
  url?: null | string;
  videoFormat?: null | string;
}

export interface ResponseContentsContentResponsePaginated {
  data: ResponseContentsContentResponse[];
  pagination: ResponsePagination;
}

export interface ResponseContentsCourseResponse {
  coverImage: ResponseCoverImageResponse;
  description?: null | string;
  /** @format int32 */
  duration: number;
  /** @format int64 */
  id: number;
  learningGoals?: null | any[];
  lessons?: null | any[];
  themes?: null | any[];
  title?: null | string;
}

export interface ResponseContentsLessonResponse {
  coverImage: ResponseCoverImageResponse;
  /** @format int32 */
  duration: number;
  engagementStatus?: null | string;
  /** @format int64 */
  id: number;
  introduction: ResponseContentsLessonResponseLessonIntroduction;
  /** @format int32 */
  lessonNo: number;
  title?: null | string;
  type?: null | string;
}

export interface ResponseContentsLessonResponseLessonIntroduction {
  description?: null | string;
  heading?: null | string;
  image: ResponseCoverImageResponse;
}

export interface ResponseContentsManagerMixedContentResponse {
  contents?: null | any[];
}

export interface ResponseContentsMixedContentResponse {
  contentCustomizedForUser: boolean;
  contents?: null | any[];
}

export interface ResponseContentsPlaybackManifestAudioResponse {
  language: string;
  url: string;
}

export interface ResponseContentsPlaybackManifestResponse {
  audio: ResponseContentsPlaybackManifestAudioResponse[];
  audioPlaylistUrl?: null | string;
  /** Shared author representation for content responses (article, audio, video playback manifest). */
  author?: ResponseContentsContentAuthorResponse | null;
  /** @format int64 */
  contentId: number;
  coverImages?: ResponseCoverImageResponse | null;
  description?: null | string;
  /** @format int32 */
  durationMs: number;
  orientation?: null | string;
  title: string;
  transcripts: ResponseContentsPlaybackManifestTranscriptResponse[];
  videoFormat?: null | string;
  videoPlaylistUrl?: null | string;
}

export interface ResponseContentsPlaybackManifestTranscriptResponse {
  language: string;
  url: string;
}

export interface ResponseContentsUpdateContentEngagementResponse {
  /** @format int64 */
  contentId: number;
  contentType?: null | string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  modifiedAt?: null | string;
  status?: null | string;
}

export interface ResponseContentsVideoResponse {
  /** @format date-time */
  createdAt: string;
  /** @format int32 */
  durationInSeconds: number;
  /** @format int64 */
  id: number;
  nativeUrl: string;
  orientation?: null | string;
  themes: string[];
  thumbnailPath: string;
  title: string;
  url: string;
  videoFormat?: null | string;
}

/** Headline counts; attendance fields are null until the session has been graded (S5). */
export interface ResponseConveneAttendanceCountsResponse {
  /** @format int32 */
  attended?: null | number;
  /** @format int32 */
  avgDurationSeconds?: null | number;
  /** @format int32 */
  cancelled: number;
  /** @format int32 */
  invited: number;
  /** @format int32 */
  noShow?: null | number;
  /** @format int32 */
  registered: number;
}

/** Email-invite funnel: invited -> opened -> registered. */
export interface ResponseConveneAttendanceFunnelResponse {
  /** @format int32 */
  invited: number;
  /** @format int32 */
  opened: number;
  /** @format int32 */
  registered: number;
}

/** One roster row. Attendance columns are null until the session has run (S5). */
export interface ResponseConveneAttendanceRowResponse {
  /** @format int32 */
  attendanceRatePercent?: null | number;
  /** @format int32 */
  durationSeconds?: null | number;
  email: string;
  employer?: null | string;
  /** @format date-time */
  joinedAt?: null | string;
  name: string;
  /** @format date-time */
  registeredAt: string;
  /** "registered" | "cancelled" | "attended" | "no-show". */
  status: string;
}

/** The session the attendance belongs to. Times are wall-clock in `TimeZone`. */
export interface ResponseConveneAttendanceSessionResponse {
  /** @format date-time */
  endsAt: string;
  /** @format uuid */
  id: string;
  /** @format date-time */
  startsAt: string;
  /** "scheduled" | "cancelled". */
  status: string;
  timeZone: string;
  title: string;
}

/** One company an event is open to. */
export interface ResponseConveneConveneEmployerResponse {
  /** @format uuid */
  id: string;
  name: string;
}

/**
 * Structured failure body matching the admin UI's error contract. For creates, `Code` is
 * "NO_HOST", "UNLICENSED_HOST", or "VALIDATION"; for edits (OI-25024) it is "SESSION_CANCELLED",
 * "SESSION_COMPLETED", or "CAPACITY_BELOW_REGISTERED".
 */
export interface ResponseConveneConveneErrorResponse {
  code: string;
  email?: null | string;
  message: string;
  /**
   * Current registered count, set for "CAPACITY_BELOW_REGISTERED".
   * @format int32
   */
  registeredCount?: null | number;
  /** @format int32 */
  sessionIndex?: null | number;
}

/** A full event with its sessions. `Audience` is always "private" here. */
export interface ResponseConveneConveneEventResponse {
  audience: string;
  /** Locale codes this event can be read in: its own plus each translated one. */
  availableLanguageCodes: string[];
  /** @format date-time */
  createdAt: string;
  description?: null | string;
  /**
   * Audience name the public event page shows instead of OpenUp.Api.Models.Response.Convene.ConveneEventResponse.EmployerName; null when
   * the employer's own name is used.
   */
  employerDisplayName?: null | string;
  /**
   * What the customer is called wherever an attendee or expert sees it: the display name when set,
   * otherwise the single company's own name.
   */
  employerName: string;
  /** Every company this event is open to, in name order. */
  employers: ResponseConveneConveneEmployerResponse[];
  /** "groupsession" (Zoom meeting) or "masterclass" (Zoom webinar). */
  eventType: string;
  /** @format uuid */
  id: string;
  /**
   * Locale code the Title/Description above are written in, e.g. "nl-NL". Null for events created
   * before multilingual content: the scheduler declares it on the next edit, and translations
   * cannot be added until they do.
   */
  languageCode?: null | string;
  /**
   * The public event page, one URL per language the event can be read in, each on the MyOpenUp
   * domain that serves that language. Handed out ready to copy; a single entry when the event has
   * one language or the environment configures no per-language domains.
   */
  publicPageUrls: ResponseConveneConveneLocalizedLinkResponse[];
  scheduledBy: string;
  sessions: ResponseConveneConveneSessionResponse[];
  /** Post-webinar third-party survey URL; null when none is set (masterclasses only). */
  surveyUrl?: null | string;
  title: string;
  /** Event copy in every language except OpenUp.Api.Models.Response.Convene.ConveneEventResponse.LanguageCode. */
  translations: ResponseConveneConveneEventTranslationResponse[];
}

/** Summary row for the shared events list. */
export interface ResponseConveneConveneEventSummaryResponse {
  employerName: string;
  /** "groupsession" (Zoom meeting) or "masterclass" (Zoom webinar). */
  eventType: string;
  /** @format uuid */
  id: string;
  /**
   * Wall-clock start of the first session in its own timezone (naive local datetime, no UTC offset).
   * @format date-time
   */
  nextSessionAt?: null | string;
  scheduledBy: string;
  /** @format int32 */
  sessionCount: number;
  title: string;
}

/** Event copy in one language other than the event's source language. */
export interface ResponseConveneConveneEventTranslationResponse {
  description?: null | string;
  /** Locale code, e.g. "nl-NL". */
  languageCode: string;
  title?: null | string;
}

/**
 * The shared events list split for the main page: upcoming (next session soonest first), past
 * (every session ended, most recently ended first), and cancelled (every session cancelled,
 * most recent first).
 */
export interface ResponseConveneConveneEventsOverviewResponse {
  cancelled: ResponseConveneConveneEventSummaryResponse[];
  past: ResponseConveneConveneEventSummaryResponse[];
  upcoming: ResponseConveneConveneEventSummaryResponse[];
}

/** Public landing details behind an invite token. */
export interface ResponseConveneConveneInviteLandingResponse {
  /** "sessionCancelled" | "registrationClosed" — set when RegistrationOpen is false. */
  closedReason?: null | string;
  employerName: string;
  /** Employer slug — pre-selects and locks the company on the MOU sign-up. */
  employerSlug?: null | string;
  /**
   * The companies a new account may attach to when signing up from this invite. Sign-up offers
   * exactly these instead of the full employer list. One entry means the company is pre-selected
   * and locked, which is what OpenUp.Api.Models.Response.Convene.ConveneInviteLandingResponse.EmployerSlug carries.
   */
  employers: ResponseConveneConveneEmployerResponse[];
  /** @format date-time */
  endsAt?: null | string;
  eventDescription?: null | string;
  /**
   * The language the session is spoken in. Not the same as the language its description is shown
   * in: a Dutch reader can be shown Dutch copy for a session still delivered in English.
   */
  eventLanguageCode?: null | string;
  eventTitle: string;
  /** "groupsession" (Zoom meeting) or "masterclass" (Zoom webinar) — drives landing styling. */
  eventType: string;
  hostAvatarUrl?: null | string;
  /** The session host (the expert with the host role); null when none is set. */
  hostFirstName?: null | string;
  hostLastName?: null | string;
  /** The address the invite was sent to — the MOU sign-up locks the email to this. */
  inviteeEmail?: null | string;
  /** False when the session was cancelled or the registration window has closed. */
  registrationOpen: boolean;
  /**
   * The language the session's own copy below actually came back in, which is not always the one
   * asked for: a session with no translation for it falls back to the event's own language. Null
   * when the event declares no source language.
   */
  resolvedLanguageCode?: null | string;
  /**
   * The session (Space) id — where the invitee is sent to claim the seat.
   * @format uuid
   */
  sessionId: string;
  sessionTitle: string;
  /** @format date-time */
  startsAt: string;
  timeZone: string;
  /**
   * Whether the authenticated caller's employer matches the event's employer. Null only when no
   * comparison applies (anonymous caller, or event without an employer); an authenticated caller
   * with no employer resolves to false. An explicit false hides the private landing and routes the
   * caller to the connect-your-employer popup.
   */
  viewerEmployerMatches?: null | boolean;
}

/** A session's company-shared registration link (OI-24714 / PRD F3b). */
export interface ResponseConveneConveneInviteLinkResponse {
  /** @format date-time */
  createdAt: string;
  /**
   * Registrations completed via the link.
   * @format int32
   */
  registeredCount: number;
  /**
   * Maximum registrations through the link; null = uncapped.
   * @format int32
   */
  seatCap?: null | number;
  /**
   * The MOU landing URL the company distributes, one per language the event can be read in. Each
   * points at the MyOpenUp domain serving that language, because MyOpenUp takes its language from
   * the domain rather than from a parameter. A single entry when the event has one language, or
   * when no per-language domains are configured for the environment.
   */
  urls: ResponseConveneConveneLocalizedLinkResponse[];
}

/** One per-invitee email invitation. `Status` is a lowercase lifecycle string. */
export interface ResponseConveneConveneInviteResponse {
  email: string;
  /** @format uuid */
  id: string;
  /** @format date-time */
  sentAt?: null | string;
  /** "sent" | "opened" | "registered" | "bounced" | "cancelled". */
  status: string;
}

/**
 * A shareable URL and the language it opens in. The language is in the origin rather than a query
 * parameter, because MyOpenUp picks its language from the domain it is served on.
 */
export interface ResponseConveneConveneLocalizedLinkResponse {
  /** Locale code, e.g. "nl-NL". */
  languageCode: string;
  /** The full URL to hand out. */
  url: string;
}

/**
 * An event as the public event page renders it. Narrower than OpenUp.Api.Models.Response.Convene.ConveneEventResponse
 * on purpose: no employer, scheduler, survey URL, capacity or Zoom ids reach an anonymous caller.
 */
export interface ResponseConveneConvenePublicEventResponse {
  /**
   * Locale codes this event can be read in, so the page's language selector offers what exists
   * instead of a fixed pair. Empty when the event declares no language.
   */
  availableLanguageCodes: string[];
  description?: null | string;
  /**
   * The companies this event is open to, carried into sign-up so someone registering from this
   * page chooses from the event's companies rather than every company OpenUp serves.
   */
  employerIds: string[];
  /** The company the event was scheduled for — the page's audience line. */
  employerName: string;
  /** "groupsession" (Zoom meeting) or "masterclass" (Zoom webinar). */
  eventType: string;
  /** @format uuid */
  id: string;
  /**
   * Locale code the Title/Description above actually came back in, so the page states a language
   * rather than assuming the one it asked for. Null when the event declares no source language.
   */
  resolvedLanguageCode?: null | string;
  /** Sessions still attendable, soonest first. Empty once they have all ended. */
  sessions: ResponseConveneConvenePublicSessionResponse[];
  title: string;
}

/** One attendable session on the public event page. */
export interface ResponseConveneConvenePublicSessionResponse {
  /**
   * Wall-clock end in OpenUp.Api.Models.Response.Convene.ConvenePublicSessionResponse.TimeZone (naive local datetime, no UTC offset).
   * @format date-time
   */
  endsAt: string;
  /** The host's full name; null when the session has no host set. */
  hostFullName?: null | string;
  /** @format uuid */
  id: string;
  /**
   * Where the register CTA points — the MOU invite handler behind the session's company-shared
   * link. Null when the session has no active link or is cancelled; the page then shows no CTA.
   */
  registrationUrl?: null | string;
  /**
   * Wall-clock start in OpenUp.Api.Models.Response.Convene.ConvenePublicSessionResponse.TimeZone (naive local datetime, no UTC offset).
   * @format date-time
   */
  startsAt: string;
  /** "scheduled" or "cancelled". */
  status: string;
  timeZone: string;
}

/** Outcome of claiming an invite. `Status`: "registered" | "alreadyRegistered". */
export interface ResponseConveneConveneRegistrationResponse {
  status: string;
}

/** A created session. `Status` is "scheduled" or "cancelled". */
export interface ResponseConveneConveneSessionResponse {
  /** @format int32 */
  capacity?: null | number;
  /**
   * Wall-clock end in OpenUp.Api.Models.Response.Convene.ConveneSessionResponse.TimeZone (naive local datetime, no UTC offset).
   * @format date-time
   */
  endsAt: string;
  experts: ResponseConveneSessionExpertResponse[];
  /** Zoom webinar id once created (null while pending / on failure). */
  externalWebinarId?: null | string;
  /** @format uuid */
  id: string;
  /** Practical notes for attendees (confirmation/reminder emails); null when not set. */
  sessionInstructions?: null | string;
  /**
   * Wall-clock start in OpenUp.Api.Models.Response.Convene.ConveneSessionResponse.TimeZone (naive local datetime, no UTC offset).
   * @format date-time
   */
  startsAt: string;
  status: string;
  timeZone: string;
  title: string;
  /** True when the title is a copy of the event title (follows event renames). */
  titleIsDefaulted: boolean;
  /** Session copy in every language except the event's source language. */
  translations: ResponseConveneConveneSessionTranslationResponse[];
}

/** Session copy in one language other than the parent event's source language. */
export interface ResponseConveneConveneSessionTranslationResponse {
  /** Locale code, e.g. "nl-NL". */
  languageCode: string;
  sessionInstructions?: null | string;
  title?: null | string;
}

/** An active employer for the company dropdown. */
export interface ResponseConveneEmployerResponse {
  /** @format uuid */
  id: string;
  name: string;
}

/**
 * Outcome of an event-level cancellation: which sessions were cancelled by this call.
 * Completed and already-cancelled sessions are skipped, so the list can be empty.
 */
export interface ResponseConveneEventCancellationResponse {
  cancelledSessionIds: string[];
}

/** An expert eligible to host on Zoom (licensed flag from the live intersection). */
export interface ResponseConveneHostableExpertResponse {
  email: string;
  fullName: string;
  licensed: boolean;
  userId: string;
}

/**
 * A private session hosted by the authenticated expert, as listed among the expert's own sessions
 * on the dashboard (OI-24707). `EventType` is "groupsession" or "masterclass"; `Status`
 * is "scheduled", "completed" or "cancelled" — "completed" is resolved on the way out, from the
 * session having ended, because no such state is persisted.
 */
export interface ResponseConveneHostedSessionResponse {
  /** Whether the expert can currently request a start link for this session. */
  canStart: boolean;
  /** @format int32 */
  capacity?: null | number;
  employerName: string;
  /** @format date-time */
  endsAt: string;
  eventTitle: string;
  eventType: string;
  languageCode?: null | string;
  /**
   * Seats taken (registrations not cancelled by the client).
   * @format int32
   */
  registeredCount: number;
  /** @format uuid */
  sessionId: string;
  /** @format date-time */
  startsAt: string;
  status: string;
  timeZone: string;
  title: string;
}

export interface ResponseConveneHostedSessionResponsePaginated {
  data: ResponseConveneHostedSessionResponse[];
  pagination: ResponsePagination;
}

/**
 * A freshly composed Zoom start link for a hosted session. The embedded token is short-lived —
 * the client must open it immediately and never persist it.
 */
export interface ResponseConveneHostedSessionStartLinkResponse {
  startUrl: string;
}

/** A session's registration + attendance summary (OI-25114 / OI-25115). */
export interface ResponseConveneSessionAttendanceResponse {
  /** Headline counts; attendance fields are null until the session has been graded (S5). */
  counts: ResponseConveneAttendanceCountsResponse;
  /** Email-invite funnel: invited -> opened -> registered. */
  funnel: ResponseConveneAttendanceFunnelResponse;
  roster: ResponseConveneAttendanceRowResponse[];
  /** The session the attendance belongs to. Times are wall-clock in `TimeZone`. */
  session: ResponseConveneAttendanceSessionResponse;
}

/**
 * An expert on a session. `Role` is one of "host", "panelist" or "cohost": the non-host role
 * depends on the event type, so a masterclass yields panelists and a group session yields
 * co-hosts. Clients must handle all three.
 */
export interface ResponseConveneSessionExpertResponse {
  fullName: string;
  role: string;
  userId: string;
}

export interface ResponseCoverImageResponse {
  large?: null | string;
  medium?: null | string;
  source?: null | string;
  thumbnail?: null | string;
}

export interface ResponseCreateUnconfirmedUserResponse {
  signature?: null | string;
  unconfirmedDataId?: null | string;
}

export interface ResponseDossierNotesResponse {
  answer?: null | string;
  /** @format int32 */
  consultId: number;
  question?: null | string;
}

export interface ResponseEmployerResponse {
  /** @format uuid */
  id: string;
  name?: null | string;
  planhatId?: null | string;
}

export interface ResponseEmployerResponsePaginated {
  data: ResponseEmployerResponse[];
  pagination: ResponsePagination;
}

export interface ResponseEmployersEmployerReferralToolkitFileResponse {
  fileName: string;
  languageCode: string;
}

export interface ResponseEmployersEmployerReferralToolkitResponse {
  description?: null | string;
  files: ResponseEmployersEmployerReferralToolkitFileResponse[];
}

export interface ResponseEmployersEmployerSsoResponse {
  /** @format uuid */
  employerId: string;
  provider?: null | string;
  ssoSupported: boolean;
}

export interface ResponseEmployersHrUserResponse {
  email?: null | string;
  firstName?: null | string;
  id?: null | string;
  lastName?: null | string;
  userId?: null | string;
}

export interface ResponseExpertsGetExpertDetailsResponse {
  isTranscriptionAllowed: boolean;
  userId?: null | string;
  worksTwentyFourSeven: boolean;
}

export interface ResponseExpertsSessionTypeLanguagePairResponse {
  language?: null | string;
  sessionType?: null | string;
}

export interface ResponseFlagsResources {
  /** @format uri */
  flagsUrl?: null | string;
}

export interface ResponseFocusAreaResources {
  /** @format uri */
  iconUrl?: null | string;
}

export interface ResponseHostClientWithRelationshipResponse {
  calendar: ResponsePsychologistCalendarsResponse;
  email?: null | string;
  /** @format uuid */
  employerId?: null | string;
  firstName?: null | string;
  id?: null | string;
  isInRelationWithCurrentPsychologist: boolean;
  isLockedOut: boolean;
  isPartner: boolean;
  isTranscriptionAllowed: boolean;
  languageCode?: null | string;
  lastName?: null | string;
  phoneNumber?: null | string;
  preferences?: null | any[];
  roles?: null | any[];
  tags?: null | any[];
  twoFactorEnabled: boolean;
  /** @format int32 */
  userNumber: number;
  /** @format int32 */
  yearOfBirth?: null | number;
}

export interface ResponseHumanResourcesEmployerResponse {
  companyCode?: null | string;
  /** @format uuid */
  id: string;
  name?: null | string;
  slug?: null | string;
}

export interface ResponseLastCompletedConsultByTypeResponse {
  expertFullName?: null | string;
  expertId?: null | string;
  expertIsAvailable?: null | boolean;
  expertProfileImageUrl?: null | string;
  expertProfileThumbnailUrl?: null | string;
  languageCode?: null | string;
  /** @format int32 */
  lastConsultId?: null | number;
  sessionType?: null | string;
}

export interface ResponseNotification {
  /** @format int32 */
  id: number;
  key?: null | string;
  /** @format date-time */
  validUntil: string;
}

/** @format int32 */
export enum ResponseOpenUpRole {
  Automation = "Automation",
  Guest = "Guest",
  Client = "Client",
  Psychologist = "Psychologist",
  Admin = "Admin",
  Manager = "Manager",
}

export interface ResponsePagination {
  /** @format int32 */
  currentPage: number;
  hasNextPage: boolean;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  total: number;
}

export interface ResponsePsychologistCalendarsResponse {
  calendarId?: null | string;
  description?: null | string;
  summary?: null | string;
  timeZone?: null | string;
}

export interface ResponsePsychologistClientResponse {
  calendar: ResponsePsychologistCalendarsResponse;
  email?: null | string;
  /** @format uuid */
  employerId?: null | string;
  firstName?: null | string;
  id?: null | string;
  isLockedOut: boolean;
  isPartner: boolean;
  isTranscriptionAllowed: boolean;
  languageCode?: null | string;
  lastName?: null | string;
  phoneNumber?: null | string;
  preferences?: null | any[];
  roles?: null | any[];
  tags?: null | any[];
  twoFactorEnabled: boolean;
  /** @format int32 */
  userNumber: number;
  /** @format int32 */
  yearOfBirth?: null | number;
}

export interface ResponsePsychologistClientResponsePaginated {
  data: ResponsePsychologistClientResponse[];
  pagination: ResponsePagination;
}

export interface ResponsePsychologistConsultInformationResponse {
  clientTimezone?: null | string;
  consultLanguage?: null | string;
  consultStage?: null | string;
  consultType?: null | string;
  employee: ResponsePsychologistResponse;
  employeeFullName?: null | string;
  guestUrl?: null | string;
  /** @format int32 */
  id: number;
  psychologistUrl?: null | string;
  /** @format date-time */
  startedAt: string;
  status?: null | string;
  themeKey?: null | string;
  user: ResponseUserResponse;
}

export interface ResponsePsychologistConsultInformationResponsePaginated {
  data: ResponsePsychologistConsultInformationResponse[];
  pagination: ResponsePagination;
}

export interface ResponsePsychologistConsultResponse {
  canJoinVideoCall: boolean;
  chatThreadId?: null | string;
  clientTimezone?: null | string;
  clientUrl?: null | string;
  consultLanguage?: null | string;
  consultStage?: null | string;
  consultType?: null | string;
  dossierNotes?: null | any[];
  employee: ResponsePsychologistResponse;
  employeeFullName?: null | string;
  /** @format int32 */
  id: number;
  notes?: null | string;
  psychologistUrl?: null | string;
  roomId?: null | string;
  /** @format date-time */
  startedAt: string;
  status?: null | string;
  themeKey?: null | string;
  user: ResponseUserResponse;
}

export interface ResponsePsychologistGetPsychologistConsultsResponse {
  canJoinVideoCall: boolean;
  chatThreadId?: null | string;
  clientTimezone?: null | string;
  consultLanguage?: null | string;
  consultStage?: null | string;
  consultType?: null | string;
  dossierNotes?: null | any[];
  employee: ResponsePsychologistResponse;
  employeeFullName?: null | string;
  employerOfClientHasReferralToolkit: boolean;
  guestUrl?: null | string;
  /** @format int32 */
  id: number;
  notes?: null | string;
  psychologistUrl?: null | string;
  roomId?: null | string;
  /** @format date-time */
  startedAt: string;
  status?: null | string;
  themeKey?: null | string;
  user: ResponseUserResponse;
}

export interface ResponsePsychologistGetPsychologistConsultsResponsePaginated {
  data: ResponsePsychologistGetPsychologistConsultsResponse[];
  pagination: ResponsePagination;
}

export interface ResponsePsychologistResponse {
  email?: null | string;
  firstName?: null | string;
  hasLinkedCalendar: boolean;
  id?: null | string;
  isActive: boolean;
  isLockedOut: boolean;
  isTranscriptionAllowed: boolean;
  languageCode?: null | string;
  lastName?: null | string;
  personalUrlHandle?: null | string;
  phoneNumber?: null | string;
  tags?: null | any[];
  worksTwentyFourSeven: boolean;
}

export interface ResponsePsychologistResponsePaginated {
  data: ResponsePsychologistResponse[];
  pagination: ResponsePagination;
}

export interface ResponsePsychologistTwoFactorNotEnforcedExpertProfileResponse {
  description?: null | string;
  email?: null | string;
  firstName?: null | string;
  hasLinkedCalendar: boolean;
  id?: null | string;
  imagePath?: null | string;
  isActive: boolean;
  isTranscriptionAllowed: boolean;
  languageCode?: null | string;
  lastName?: null | string;
  personalUrlHandle?: null | string;
  quote?: null | string;
  specialisation?: null | string;
  supportedLanguages?: null | any[];
  tags?: null | any[];
  thumbnailPath?: null | string;
  topics?: null | any[];
  /** @format int32 */
  userNumber: number;
  worksTwentyFourSeven: boolean;
}

export interface ResponsePsychologistTwoFactorNotEnforcedExpertProfileResponsePaginated {
  data: ResponsePsychologistTwoFactorNotEnforcedExpertProfileResponse[];
  pagination: ResponsePagination;
}

export interface ResponsePsychologistTwoFactorNotEnforcedPsychologistResponse {
  email?: null | string;
  firstName?: null | string;
  hasLinkedCalendar: boolean;
  id?: null | string;
  isActive: boolean;
  isTranscriptionAllowed: boolean;
  languageCode?: null | string;
  lastName?: null | string;
  personalUrlHandle?: null | string;
  tags?: null | any[];
  /** @format int32 */
  userNumber: number;
  worksTwentyFourSeven: boolean;
}

export interface ResponseQuestionListScoreResponse {
  category: ModelsEnumCategory;
  categoryTitle?: null | string;
  /** @format date-time */
  createdAt: string;
  key?: null | string;
  /** @format double */
  score: number;
  scoreDescription?: null | string;
  scoreIconInUnicode?: null | string;
  scoreTitle?: null | string;
  /** @format uuid */
  userId: string;
}

export interface ResponseQuestionListScoreResponsePaginated {
  data: ResponseQuestionListScoreResponse[];
  pagination: ResponsePagination;
}

export interface ResponseReportingCompanyOverTimeDataResponse {
  /** @format int64 */
  count: number;
  /** @format int32 */
  month: number;
  /** @format int32 */
  year: number;
}

export interface ResponseReportingCompanyOverTimeGroupedDataResponse {
  /** @format int64 */
  count: number;
  /** @format int32 */
  month: number;
  type?: null | string;
  /** @format int32 */
  year: number;
}

export interface ResponseReportingGetGroupedOverTimeReportDataResponse {
  monthlyActivityRecords?: null | any[];
  /** @format int64 */
  total: number;
}

export interface ResponseReportingGetOverTimeReportDataResponse {
  monthlyActivityRecords?: null | any[];
  /** @format int64 */
  total: number;
}

export interface ResponseReportingGetSessionsTopicsDataResponse {
  employerId?: null | string;
  /** @format int64 */
  sessionsCount?: null | number;
  themeKey?: null | string;
  topicName?: null | string;
}

export interface ResponseResourcesUrls {
  flags: ResponseFlagsResources;
  focusArea: ResponseFocusAreaResources;
  sessionType: ResponseSessionTypeResources;
  theme: ResponseThemeResources;
}

export interface ResponseSendBirdSessionToken {
  /** @format int64 */
  expiresAt: number;
  token?: null | string;
}

export interface ResponseSessionTypeResources {
  /** @format uri */
  bookingImagesUrl?: null | string;
  /** @format uri */
  iconUrl?: null | string;
}

export interface ResponseSpacesGetClientSpaceResponse {
  /** @format date-time */
  date: string;
  experts?: null | any[];
  languageCode?: null | string;
  /** @format uuid */
  spaceId: string;
  status?: null | string;
  timezone?: null | string;
  title?: null | string;
  type?: null | string;
}

export interface ResponseSpacesGetClientSpaceResponsePaginated {
  data: ResponseSpacesGetClientSpaceResponse[];
  pagination: ResponsePagination;
}

export interface ResponseSpacesSpaceResponse {
  /** @format date-time */
  dateTime: string;
  isFull: boolean;
  isUserRegistered: boolean;
  language?: null | string;
  theme?: null | string;
  title?: null | string;
  type?: null | string;
}

export interface ResponseSpacesSpaceSearchResultResponse {
  description?: null | string;
  /** @format int32 */
  durationInSeconds: number;
  eventType: ModelsAiSearchSlugNamePair;
  id?: null | string;
  /** @format date-time */
  nextSessionAt?: null | string;
  /** @format int32 */
  sessionCount: number;
  speakerDetails?: null | any[];
  speakers?: null | any[];
  themes?: null | any[];
  title?: null | string;
  translationLanguages?: null | any[];
}

export interface ResponseSpacesSpaceSearchResultResponsePaginated {
  data: ResponseSpacesSpaceSearchResultResponse[];
  pagination: ResponsePagination;
}

export interface ResponseSpacesSpaceUserResponse {
  /** @format date-time */
  dateTime: string;
  errorMessage?: null | string;
  spaceConnectionLink?: null | string;
  spaceExperts?: null | string;
  spaceLanguage?: null | string;
  spaceTheme?: null | string;
  spaceTitle?: null | string;
  spaceType?: null | string;
  spotsAvailable: boolean;
  status?: null | string;
  timezone?: null | string;
  userEmail?: null | string;
  userName?: null | string;
}

export interface ResponseTag {
  description?: null | string;
  name?: null | string;
  tagType: ResponseTagType;
  translations?: null | any[];
}

export interface ResponseTagType {
  isExclusive: boolean;
  name?: null | string;
}

export interface ResponseTagsExpertTag {
  description?: null | string;
  tagName?: null | string;
  tagType?: null | string;
}

export interface ResponseThemeResources {
  /** @format uri */
  iconUrl?: null | string;
  /** @format uri */
  onboardingImagesUrl?: null | string;
  /** @format uri */
  themePageImageUrl?: null | string;
}

export interface ResponseThemeResponse {
  isFocused: boolean;
  key?: null | string;
  /** @format int32 */
  ordinal?: null | number;
  tags?: null | any[];
  /** @format uuid */
  themeDefinitionId: string;
}

export interface ResponseTwoFactorCodeResponse {
  isEligibleToRequestNewCode: boolean;
  message?: null | string;
  phoneNumber?: null | string;
  /** @format int32 */
  timeout: number;
}

export interface ResponseTwoFactorNotEnforcedAvatarResponse {
  large?: null | string;
  medium?: null | string;
  src?: null | string;
  thumbnail?: null | string;
}

export interface ResponseTwoFactorNotEnforcedBookNonConfirmedConsultResponse {
  calendarEventId?: null | string;
  /** @format date-time */
  createdAt: string;
  employeeId?: null | string;
  /** @format uuid */
  id: string;
  isConfirmationReminderEmailSent: boolean;
  sessionToken?: null | string;
  /** @format date-time */
  startedAt: string;
  tags?: null | any[];
  userEmail?: null | string;
}

export interface ResponseTwoFactorNotEnforcedConsultResponse {
  canJoinVideoCall: boolean;
  chatThreadId?: null | string;
  clientEmail?: null | string;
  clientFirstName?: null | string;
  clientId?: null | string;
  clientTimezone?: null | string;
  consultLanguage?: null | string;
  consultType?: null | string;
  employeeFullName?: null | string;
  employeeId?: null | string;
  employeeImageUrl?: null | string;
  /** @format int32 */
  employeeNumber: number;
  employeePersonalUrlHandle?: null | string;
  employeeThumbnailUrl?: null | string;
  /** @format int32 */
  id: number;
  roomId?: null | string;
  /** @format date-time */
  startedAt: string;
  status?: null | string;
  themeKey?: null | string;
}

export interface ResponseTwoFactorNotEnforcedDescriptionResponse {
  content?: null | any[];
  text?: null | string;
  textStyle?: null | string;
  type?: null | string;
}

export interface ResponseTwoFactorNotEnforcedEventTypeResponse {
  name?: null | string;
  slug?: null | string;
}

export interface ResponseTwoFactorNotEnforcedGetSpaceEventResponse {
  description?: null | any[];
  /** @format int32 */
  duration: number;
  eventType: ResponseTwoFactorNotEnforcedEventTypeResponse;
  id?: null | string;
  language?: null | string;
  sessions?: null | any[];
  themes?: null | any[];
  title?: null | string;
  translations?: null | any[];
}

export interface ResponseTwoFactorNotEnforcedGetSpaceEventResponsePaginated {
  data: ResponseTwoFactorNotEnforcedGetSpaceEventResponse[];
  pagination: ResponsePagination;
}

export interface ResponseTwoFactorNotEnforcedSpaceEventThemeResponse {
  name?: null | string;
}

export interface ResponseTwoFactorNotEnforcedSpaceSessionResponse {
  /** @format date-time */
  endedAt: string;
  id?: null | string;
  speakers?: null | any[];
  /** @format date-time */
  startedAt: string;
  timezone?: null | string;
}

export interface ResponseTwoFactorNotEnforcedSpeakerResponse {
  avatar: ResponseTwoFactorNotEnforcedAvatarResponse;
  firstName?: null | string;
  lastName?: null | string;
}

export interface ResponseTwoFactorNotEnforcedTag {
  description?: null | string;
  name?: null | string;
  tagType: ResponseTagType;
  translations?: null | any[];
}

export interface ResponseTwoFactorNotEnforcedTranslationResponse {
  eventId?: null | string;
  language?: null | string;
}

export interface ResponseTwoFactorNotEnforcedUnorderedListContentResponse {
  text?: null | string;
  textStyle?: null | string;
  type?: null | string;
}

export interface ResponseTwoFactorNotEnforcedUserResponse {
  email?: null | string;
  /**
   * Boolean indicating whether the user has a valid phone number associated with their account
   * Calculated at runtime.
   */
  hasValidPhoneNumber: boolean;
  /** Boolean indicating whether details of the user have been saved */
  isRegistered: boolean;
  languageCode?: null | string;
  /** List of external 2FA token providers set up by user */
  userTokenProviders?: null | any[];
}

export interface ResponseUserPreferenceResponse {
  category?: null | string;
  name?: null | string;
  value: boolean;
}

export interface ResponseUserResponse {
  /** @format date-time */
  createdAt: string;
  email?: null | string;
  /** @format uuid */
  employerId?: null | string;
  employerName?: null | string;
  firstName?: null | string;
  /**
   * Boolean indicating whether the user has a valid phone number associated with their account
   * Calculated at runtime.
   */
  hasValidPhoneNumber: boolean;
  id?: null | string;
  /**
   * Whether AI personalised recommendations are enabled for the user.
   * Read from the AI_PREFERENCES / aiPersonalisedRecommendations preference; true when no record exists.
   */
  isAiPersonalisedRecommendationsEnabled: boolean;
  isEmailConfirmed: boolean;
  isFocusThemeSet: boolean;
  isGuestLogin: boolean;
  isManager: boolean;
  isPartner: boolean;
  isRegistered: boolean;
  isRegisteredWithPassword: boolean;
  isTranscriptionAllowed: boolean;
  languageCode?: null | string;
  lastName?: null | string;
  loginProvider?: null | string;
  phoneNumber?: null | string;
  phoneNumberConfirmed: boolean;
  preferences?: null | any[];
  roles?: null | any[];
  signUpToNewsletter: boolean;
  twoFactorEnabled: boolean;
  /** List of external 2FA token providers set up by user */
  userTokenProviders?: null | any[];
  /** @format int32 */
  yearOfBirth?: null | number;
}

export interface ResponseUserResponsePaginated {
  data: ResponseUserResponse[];
  pagination: ResponsePagination;
}

export interface ResponseUsersUserWithNameAndEmployerIdResponse {
  /** @format uuid */
  employerId?: null | string;
  firstName?: null | string;
  id?: null | string;
  lastName?: null | string;
}

export interface ResponseVitalityCheckinCompletedCheckinsResponse {
  /** @format date-time */
  nextCheckinDate?: null | string;
  /** @format date-time */
  previousCheckinDate?: null | string;
}

export interface ResponseVitalityCheckinLastVitalityCheckinDateResponse {
  /** @format date-time */
  lastLegacyCheckinDate?: null | string;
  /** @format date-time */
  lastVitalityCheckinDate?: null | string;
}

export interface ResponseVitalityCheckinVitalityCheckinAnswerResponse {
  /** @format int32 */
  intValue?: null | number;
  textValue?: null | string;
}

export interface ResponseVitalityCheckinVitalityCheckinModuleResponse {
  moduleName?: null | string;
  /** @format int32 */
  order: number;
  themeKey?: null | string;
}

export interface ResponseVitalityCheckinVitalityCheckinModuleScoreResponse {
  category?: null | string;
  /** @format date-time */
  createdAt: string;
  isFocusedTheme: boolean;
  key?: null | string;
  /** @format double */
  progressPercent?: null | number;
  questionsWithAnswers?: null | any[];
  /** @format double */
  score: number;
  scoreDescription?: null | string;
  scoreTitle?: null | string;
  themeKey?: null | string;
}

export interface ResponseVitalityCheckinVitalityCheckinOverallScoreResponse {
  aiStrengths?: null | any[];
  aiSummary?: null | any[];
  /** @format date-time */
  checkinDateTime?: null | string;
  completedCheckins: ResponseVitalityCheckinCompletedCheckinsResponse;
  isFollowUpCheckinComplete: boolean;
  moduleScores?: null | any[];
  /** @format date-time */
  nextCheckinDateTime?: null | string;
  overallScoreCategory?: null | string;
}

export interface ResponseVitalityCheckinVitalityCheckinQuestionsWithAnswersResponse {
  answers?: null | any[];
  isScored: boolean;
  questionKey?: null | string;
  questionText?: null | string;
  questionType?: null | string;
  /** @format double */
  score?: null | number;
}

export interface ResponseVitalityCheckinVitalityCheckinRecommendationItemResponse {
  /**
   * Content duration in seconds (0 for a session).
   * @format int32
   */
  durationInSeconds: number;
  /** @format uuid */
  id: string;
  /** @format int32 */
  order: number;
  reason?: null | string;
  status?: null | string;
  title?: null | string;
  /** Content type: article, video, course, space, or session. */
  type?: null | string;
  /** Content id (or session/space id) the item points to. */
  value?: null | string;
}

export interface ResponseVitalityCheckinVitalityCheckinRecommendationPlanResponse {
  /** @format date-time */
  checkinDate: string;
  /** @format uuid */
  id: string;
  items?: null | any[];
  status?: null | string;
}

export interface ResponseVitalityCheckinVitalityCheckinScoreOverTimeResponse {
  overallScoreOverTime?: null | any[];
  themeListScoreOverTime?: null | any[];
}

export interface ResponseVitalityCheckinVitalityCheckinScoreResponse {
  /** @format date */
  checkinDate: string;
  /** @format double */
  score: number;
}

export interface ResponseVitalityCheckinVitalityCheckinThemeScoreOverTimeResponse {
  scoresOverTime?: null | any[];
  themeKey?: null | string;
}

/**
 * Transiently-calculated status band for a single vitality check-in theme, computed from the
 * answers supplied in the request. Includes the localized band title and description; deeper
 * result content (insights, recommendations) stays gated behind the final results endpoints.
 */
export interface ResponseVitalityCheckinVitalityCheckinThemeStatusResponse {
  category: string;
  categoryDescription?: null | string;
  categoryTitle?: null | string;
  /** @format double */
  score: number;
  themeKey: string;
}

export type SaveVitalityCheckinAnswersPayload = ModelsQuestionListAnswers[];

export interface SearchFaqParams {
  /** The user's question, used for semantic vector matching against the FAQ index. */
  question?: string;
}

export interface SearchParams {
  channel_url?: string;
  user_id?: string;
}

export interface SearchParams2 {
  audience?: string;
  languageCode: string;
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
  searchTerm: string;
  types?: string[];
}

export interface SearchSpacesParams {
  audience?: string;
  eventTypes?: string[];
  languageCode?: string;
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
  searchTerm?: string;
  themes?: string[];
}

export interface SendEmailVerificationParams {
  /** The email address to which this verification link will be sent */
  email?: string;
  /** The Uri where user should be redirected after verification of the email address */
  redirectUri?: string;
}

export interface ServicesSendBirdModelsSendBirdUser {
  access_token?: null | string;
  /** @format int64 */
  created_at: number;
  discovery_keys?: null | any[];
  has_ever_logged_in: boolean;
  is_active: boolean;
  is_online: boolean;
  /** @format int64 */
  last_seen_at: number;
  metadata?: null | object;
  nickname?: null | string;
  preferred_languages?: null | any[];
  profile_url?: null | string;
  /** @format int32 */
  unread_message_count: number;
  user_id?: null | string;
}

export type SetConsultTagsPayload = string[];

export type SetFocusedThemesPayload = string[];

export type SetPsychologistThemesPayload = string[];

export type SetUserCurrentMoodsPayload = string[];

export type SetUserPreferencesBody = ModelsUserPreference[];

export type SetUserTagsPayload = string[];

export interface TestModelsTestCalendar {
  calendarId?: null | string;
  refreshToken?: null | string;
}

export interface TestModelsTestConsult {
  session24AccessKey?: null | string;
  session24Id?: null | string;
  clientTimezone?: null | string;
  consultLanguage?: null | string;
  consultStage?: null | string;
  consultType?: null | string;
  employeeEmail?: null | string;
  meetingProvider: ModelsConsultMeetingProvider;
  notes?: null | string;
  /** @format int32 */
  notesAvailableAt?: null | number;
  /** @format int32 */
  startedAt: number;
  startedAtOffsetByMinutes: boolean;
  status?: null | string;
  themeKey?: null | string;
}

export interface TestModelsTestExternalQuestionnaire {
  /** @format int32 */
  createdAt: number;
  /** @format uuid */
  externalId: string;
  type?: null | string;
}

export interface TestModelsTestSpace {
  /** @format date-time */
  attendanceDate: string;
  /** @format int32 */
  attendanceRate?: null | number;
  /** @format int32 */
  capacity: number;
  /** @format int64 */
  date: number;
  experts?: null | any[];
  externalSpaceId?: null | string;
  externalSpaceTypeId?: null | string;
  spaceUserStatus?: null | string;
  theme?: null | string;
  timeZone?: null | string;
  title?: null | string;
}

export interface TestModelsTestSpaceExpert {
  email?: null | string;
  firstName?: null | string;
  lastName?: null | string;
}

export interface TestModelsTestTag {
  type?: null | string;
  values?: null | any[];
}

export interface TestModelsTestUser {
  calendar: TestModelsTestCalendar;
  completeQuestionLists: boolean;
  consults?: null | any[];
  createByPsychologist: boolean;
  createdBy?: null | string;
  email?: null | string;
  /** @format uuid */
  employerId?: null | string;
  externalQuestionnaires?: null | any[];
  firstName?: null | string;
  isLockedOut: boolean;
  languageCode?: null | string;
  lastName?: null | string;
  password?: null | string;
  phoneNumber?: null | string;
  roles?: null | any[];
  sendBirdUserId?: null | string;
  spaces?: null | any[];
  tags?: null | any[];
  /** @format int32 */
  userNumber: number;
  /** @format int32 */
  yearOfBirth: number;
}

export interface UpdateInvitationLinkStatusParams {
  channelId: string;
  isEnabled?: boolean;
}

export type UpdateLanguageAvailabilityPayload =
  RequestExpertsSessionTypeLanguagePairRequest[];

export interface UpdateUserLanguageParams {
  logout?: boolean;
}

export interface UpdateUserPhoneNumberWithTokenParams {
  token?: string;
}

export interface UploadChatAttachmentPayload {
  /** @format binary */
  file?: File;
}

export interface UploadReferralToolkitPayload {
  /** @format binary */
  file?: File;
}

export interface UploadSessionNoteAttachmentPayload {
  /** @format binary */
  file?: File;
}
